var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from "react";
import { Spring } from "react-spring";
import idx from "idx";

var Blur = function (_React$Component) {
  _inherits(Blur, _React$Component);

  function Blur() {
    _classCallCheck(this, Blur);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Blur.prototype.render = function render() {
    var _props = this.props,
        reveal = _props.reveal,
        children = _props.children,
        props = _objectWithoutProperties(_props, ["reveal", "children"]);

    return React.createElement(
      Spring,
      _extends({}, props, {
        from: {
          blur: 10
        },
        to: {
          blur: reveal ? 0 : 10
        }
      }),
      function (_ref) {
        var blur = _ref.blur;

        var childStyle = idx(children, function (_) {
          return _.props.style;
        }) || {};

        var style = _extends({}, childStyle, {
          filter: "blur(" + blur + "px)"
        });

        return React.cloneElement(children, _extends({}, children.props, {
          style: style
        }));
      }
    );
  };

  return Blur;
}(React.Component);

Blur.defaultProps = {
  reveal: true
};


export default Blur;